// extracted by mini-css-extract-plugin
export default {"Container":"ImgDisplay_Container__rTM8z","Img":"ImgDisplay_Img__Xt0Td"};